export { default } from './TextareaAutosize';
